import api from '../../../api/index';
import apiShopkeeperApp from '../../../api/shopkeeperAppApi';

export default {
  getMelhorEnvioEnabledIntegration({ rootGetters }, { construpUserId }) {
    const queryParams = `?construpUserId=${construpUserId || ''}`;

    return apiShopkeeperApp.get(`/integration/melhor-envio${queryParams}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getMelhorEnvioAuthUrl({ rootGetters }, { construpUserId }) {
    const queryParams = `?construpUserId=${construpUserId || ''}`;

    return apiShopkeeperApp.get(
      `/integration/melhor-envio/authorization-url${queryParams}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  updateMelhorEnvioEnabledIntegrationStatus(
    { rootGetters },
    { construpUserId, status }
  ) {
    return apiShopkeeperApp.put(
      `/integration/melhor-envio/status`,
      { construpUserId, status },
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  saveMelhorEnvioEnabledIntegration({ rootGetters }, fields) {
    return apiShopkeeperApp.post(`/integration/melhor-envio`, fields, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  payMelhorEnvioFreight({ rootGetters }, fields) {
    return apiShopkeeperApp.post(
      `/integration/melhor-envio/pay-freight`,
      fields,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  printMelhorEnvioLabel({ rootGetters }, fields) {
    return apiShopkeeperApp.post(
      `/integration/melhor-envio/print-label`,
      fields,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  sendMelhorEnvioFreight({ rootGetters }, fields) {
    return apiShopkeeperApp.post(
      `/integration/melhor-envio/send-freight`,
      fields,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getTrackingMelhorEnvioUrl({ rootGetters }, { construpUserId, paymentId }) {
    return apiShopkeeperApp.get(
      `/integration/melhor-envio/tracking-url?construpUserId=${construpUserId}&paymentId=${paymentId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
};
